import {Rest} from './rest';

export async function fetchGlossary(user, reportType, language = 'ES') {
  const terms = await Rest.authFetch(user, `/rest/reference/glossary?reportType=${reportType}&language=${language}`, {
    headers: { accept: 'application/json' }
  });
  return Array.isArray(terms) ? terms : [];
}

export function buildGlossaryIndex(terms) {
  // Normalize to a Set and a map for definitions
  const byTerm = new Map();
  const set = new Set();
  const ordered = [];
  terms.forEach(t => {
    if (t && t.term) {
      const key = t.term.trim();
      set.add(key);
      byTerm.set(key, { definition: t.definition, example: t.example });
      ordered.push(key);
    }
  });
  // Sort by length desc for potential external usages
  ordered.sort((a, b) => b.length - a.length);
  return { set, byTerm, terms: ordered };
}
